"use client";
import React from 'react';
import { createPortal } from 'react-dom';

export default function Portal({ children }: { children: React.ReactNode }){
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(()=>{ setMounted(true); return ()=>setMounted(false); }, []);
  if (!mounted) return null;
  return createPortal(children, document.body);
}
